
const eventMapping = {

  corro_ninos_2026: {
    titulo: "RUTA YO CORRO POR LOS NIÑOS 6K",
    descripcion:
      "Conoce el recorrido de Yo Corro por los Niños 2026.",

    wikilocUrl: "https://es.wikiloc.com/wikiloc/embedv2.do?id=293825662&elevation=off&images=on&maptype=H",

    proximamente: false
  },

  corro_ninos_mascotas_2026: {
    titulo: "RUTA YO CORRO POR LOS NIÑOS 2K",
    descripcion:
      "Recorrido especial para mascotas y sus dueños en la carrera Yo Corro por los Niños 2026.",

    wikilocUrl: "https://es.wikiloc.com/wikiloc/embedv2.do?id=287449144&elevation=off&images=on&maptype=H",

    proximamente: false
  }
};

export default eventMapping;